import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { firstValueFrom, throwError } from 'rxjs';
import { first, map } from 'rxjs/operators';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AppHttpClientService {
  private readonly httpClient = inject(HttpClient);
  private readonly backendUrl = environment.backend.url;
  private readonly defaultProperties = { withCredentials: true };

  get<T>(url: string, mapperFn?: (res: any) => T) {
    const defaultMapperFn = (res: any) => res.data as T;

    return firstValueFrom(
      this.httpClient
        .get<T>(`${this.backendUrl}/${url}`, this.defaultProperties)
        .pipe(map(mapperFn || defaultMapperFn), first())
    );
  }

  post<T>(url: string, body: any) {
    return firstValueFrom(
      this.httpClient
        .post(`${this.backendUrl}/${url}`, body, {
          observe: 'response',
          ...this.defaultProperties,
        })
        .pipe(map((res) => this.handleResponse<T>(res) as T))
    );
  }

  put<T>(url: string, body: any) {
    return firstValueFrom(
      this.httpClient
        .put(`${this.backendUrl}/${url}`, body, {
          observe: 'response',
          ...this.defaultProperties,
        })
        .pipe(map((res) => this.handleResponse<T>(res) as T))
    );
  }

  delete<T>(url: string, id: any = null) {
    const finalUrl = `${url}${id ? '/' + id : ''}`;
    return firstValueFrom(
      this.httpClient
        .delete(`${this.backendUrl}/${finalUrl}`, {
          observe: 'response',
          ...this.defaultProperties,
        })
        .pipe(map((res) => this.handleResponse<T>(res) as T))
    );
  }

  private readonly handleResponse = <T>(res: HttpResponse<any>) =>
    res.status === 204
      ? {}
      : ((res.body.data as T) ?? throwError(() => res.body));
}
